import { type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellFooter = (props: Props) => {
  const { children, style } = props;

  return <View style={[styles.container, style]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing['2'],
    paddingBottom: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  style?: ViewStyle;
}>;
